import React from 'react';
import CategoryTemplate from 'templates/category';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql } from 'gatsby';

const CategoryPage = () => {
  const [t] = useTranslation();
  const image = useStaticQuery(graphql`
    query {
      strapiCategory(slug: { eq: "tradgard" }) {
        image {
          childImageSharp {
            fluid(maxHeight: 1024, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `);
  return (
    <CategoryTemplate
      heading={t('page--gardening.heading')}
      subheading={t('page--gardening.subheading')}
      buttonLabel={t('page--gardening.buttonLabel')}
      content={t('page--gardening.content')}
      image={image.strapiCategory.image}
      ctaTitle={t('page--gardening.ctaTitle')}
      seoTitle={t('page--gardening.seoTitle')}
      seoDescription={t('page--gardening.seoDescription')}
    />
  );
};
export default CategoryPage;
